//  Angular
import { Component, HostBinding, OnInit, OnDestroy } from '@angular/core';

// NGRX & RXJS
import { select, Store } from '@ngrx/store';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';

//  OLCI
import * as olciUtil from '../../util';
import * as olci from '../../actions/olci';
import * as fromRoot from '../../reducers';
import { constants } from '../../constants';
import * as tracking from '../../actions/tracking';
import { slideInDownAnimation } from '../../animation';
import { LoaderService } from '../../modules/loading/loader.service';
import { BookingService } from '../../modules/core/services/booking.service';
import { GatingServices } from '../../modules/core/services/gating.services';
import { TealiumService } from 'src/app/modules/core/services/tealium.service';
import { ResourceBundleService } from '../../modules/core/services/resource-bundle.service';
import { FeatureFlagDictionaryEnum } from 'src/app/shared/enums/feature-flag-dictionary.enum';
import { FeatureFlagsService } from 'src/app/modules/core/services/feature-flags.service';

@Component({
    selector: 'app-error',
    templateUrl: './error-page.container.html',
    styleUrls: ['./error-page.container.scss'],
    animations: [slideInDownAnimation],
    standalone: false
})
export class ErrorPageContainerComponent implements OnInit, OnDestroy {
	@HostBinding('@routeAnimation') routeAnimation = true;

	public referer: any;
	public showMenu: boolean;
	public constants: any;
	public resRetrieval: any;
	public bundle: any;
	public isSafari: boolean;
	public brandCorpAltText: any;
	public brandName: any;
	public brandUrl: any;
	public screensize:any;
	public shouldDisplayMessageCenter = false;
	public hideMessageCenterContainer = true;

	private readonly exitModal: any;
	private defaultBundle: BehaviorSubject<any>;
	private screensizeSub: Subscription;
	public screensize$: Observable<any>;

	constructor(
		private readonly gatingServices: GatingServices,
		public resourceBundle: ResourceBundleService,
		private readonly loader: LoaderService,
		private readonly store: Store<fromRoot.AppState>,
		private readonly bookingService: BookingService,
		private readonly tealiumService: TealiumService,
		private readonly featureFlagsService: FeatureFlagsService
	) {
		this.showMenu = false;
		this.constants = constants;
		this.resRetrieval = this.bookingService.isInTheStore;
		this.brandName = this.bookingService.getBrand();
		this.brandCorpAltText = this.bookingService.getBrandCorpAltText();
		this.exitModal = constants.MODAL.EXIT;
		this.brandUrl = this.gatingServices.getBrandURL();
		this.screensize$ = this.store.pipe(select(fromRoot.getContentScreenSize));
	}

	public ngOnInit(): void {
		this.loader.hideLoader();
		this.referer = olciUtil.readLocalSorage('referrer');
		this.tealiumService.analyticsInfoNotAvailable();
		this.isSafari = olciUtil.isSafari();
		this.defaultBundle = new BehaviorSubject<any>({
			'user.menu.label.my.account': 'My Account',
			'header.user.menu.profile': 'Settings',
			'header.user.menu.reservations': 'Upcoming cruises',
			'button.past.cruise': 'Past cruises',
			'button.curtesy.holds': 'Courtesy holds',
			'header.user.menu.royal.gifts': 'Royal Gifts',
			'button.help': 'FAQ',
			"button.my.message":"My messages",
			'header.user.menu.sign.out': 'Sign out',
			'error.technical.difficulties.header': 'Information is currently not available. Please try again later.',
			'error.technical.difficulties.subheader': 'Please check back in a few and/or refresh your browser.',
			'error.technical.difficulties.button.dashboard': 'Back to My account'
		});
		this.bundle = this.resourceBundle.bundleSnapshot ? this.resourceBundle.bundle : this.defaultBundle;
		this.freeBooking();
		this.shouldDisplayMessageCenter =
			  this.featureFlagsService.snapshot[
				FeatureFlagDictionaryEnum.MESSAGING_CENTER
			  ];
	  this.screensizeSub = this.screensize$.subscribe(value => {
      this.screensize = value;
      // Call displayBadgeOnProfile when screensize changes to desktop
      if (value?.isdesktop) {
        this.displayBadgeOnProfile(false);
      }
    });
	}

	private freeBooking(): void {
		this.bookingService.signOut()?.pipe(take(1));
	}

	public goToDashboard(): void {
		this.store.dispatch(new tracking.TrackPageInteractionEventAction('error page: go to dashboard link'));
		this.store.dispatch(new olci.ClearStateOnlyAction());
		window.location.href = this.gatingServices.getGAAccountURL();
	}

	public goToBrandUrl(event: any): void {
		event.preventDefault();
		this.store.dispatch(new olci.OpenModalAction({ name: this.exitModal, url: this.brandUrl }));
		this.store.dispatch(new tracking.TrackPageInteractionEventAction('brand icon'));
		this.store.dispatch(new olci.ClearStateOnlyAction());
		window.location.href = this.gatingServices.getGAAccountURL();
	}
	displayBadgeOnProfile(event: boolean) {
		olciUtil.displayBadgeOnProfile(event, 'error-page-header__rcl-menu-button');
	}
	public toggleShowMenu() {
		this.showMenu = !this.showMenu;
		if (this.showMenu && this.hideMessageCenterContainer) {
			this.hideMessageCenterContainer = false;
		} else {
			this.hideMessageCenterContainer = true;
		}
	}
	ngOnDestroy() {
		if (this.screensizeSub) {
			this.screensizeSub.unsubscribe();
		}
	}
}
